var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formUrl
    ? _c("div", { staticClass: "c-login-block" }, [
        _c(
          "div",
          {
            staticClass:
              "c-login-block__hero-wrapper c-hero t-padding--v-l variant--secondary",
          },
          [
            _vm.header
              ? _c("div", { staticClass: "o-width-limiter c-hero__inner" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "c-hero__content c-hero__content--align-center",
                    },
                    [
                      _c("h1", { staticClass: "c-hero__title" }, [
                        _vm._v(_vm._s(_vm.header)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-hero__text" }, [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.description) +
                              "\n          "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.formUrl
          ? _c(
              "div",
              {
                staticClass: "c-login-block__bottom-wrapper",
                style: _vm.backgroundStyle,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-login-block__form-wrapper",
                    style: _vm.formWrapperStyle,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-login-form-block",
                        style: _vm.formBlockStyle,
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-login-form-block__inner" },
                          [
                            _c(
                              "form",
                              {
                                staticClass: "form-block",
                                attrs: { action: _vm.formUrl, novalidate: "" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submitForm.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-login-form-block__group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.firstName,
                                          expression: "firstName",
                                        },
                                      ],
                                      class: {
                                        filled:
                                          _vm.firstName || _vm.errors.firstName,
                                      },
                                      attrs: {
                                        name: "firstname",
                                        type: "text",
                                        placeholder: _vm.firstNameLabel,
                                        "aria-invalid": !!_vm.errors.firstName,
                                        required: "",
                                      },
                                      domProps: { value: _vm.firstName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.firstName = $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.errors.firstName
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c-login-form-block__error",
                                            attrs: { role: "alert" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.errors.firstName) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "c-login-form-block__group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lastName,
                                          expression: "lastName",
                                        },
                                      ],
                                      class: {
                                        filled:
                                          _vm.lastName || _vm.errors.lastName,
                                      },
                                      attrs: {
                                        type: "text",
                                        name: "lastname",
                                        placeholder: _vm.lastNameLabel,
                                        "aria-invalid": !!_vm.errors.lastName,
                                        required: "",
                                      },
                                      domProps: { value: _vm.lastName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.lastName = $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.errors.lastName
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c-login-form-block__error",
                                            attrs: { role: "alert" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.errors.lastName) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "c-login-form-block__group" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.email,
                                          expression: "email",
                                        },
                                      ],
                                      class: {
                                        filled: _vm.email || _vm.errors.email,
                                      },
                                      attrs: {
                                        type: "email",
                                        name: "email",
                                        placeholder: _vm.EmailLabel,
                                        "aria-invalid": !!_vm.errors.email,
                                        required: "",
                                      },
                                      domProps: { value: _vm.email },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.email = $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.errors.email
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c-login-form-block__error",
                                            attrs: { role: "alert" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.errors.email) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-login-form-block__btn-wrapper",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "c-button",
                                        attrs: { type: "submit" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.SubmitLabel) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.successMessage
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-login-form-block__success",
                                        attrs: { role: "status" },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.successMessage) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errorMessage
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-login-form-block__error",
                                        attrs: { role: "alert" },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.errorMessage) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }